import React, { useEffect, useRef } from "react";
import {
  FaShip,
  FaMoneyCheckAlt,
  FaArrowRight
} from "react-icons/fa";
import "../styles/ourservices.css";

const OurServices = () => {

 const servicesRef = useRef(null);


    useEffect(() => {
    const revealElements = servicesRef.current.querySelectorAll("[data-reveal]");

    const scrollReveal = () => {
      for (let i = 0; i < revealElements.length; i++) {
        const elementIsInScreen =
          revealElements[i].getBoundingClientRect().top <
          window.innerHeight / 1.15;

        if (elementIsInScreen) {
          revealElements[i].classList.add("revealed");
        } else {
          revealElements[i].classList.remove("revealed");
        }
      }
    };

    window.addEventListener("scroll", scrollReveal);
    scrollReveal();

    return () => {
      window.removeEventListener("scroll", scrollReveal);
    };
  }, []);

  return (
    <div className="services-section" ref={servicesRef}>
      <div className="services-wrapper">
      <div className="top-header featured__header">
      <span data-reveal>  Our Services </span>
      <h3 data-reveal>Importation & Financing Made Simple</h3>

        <div className="line-wrapper" data-reveal>
          <div className="short-line"></div>
           <div className="short-line"></div>

        </div>  

      </div>

        <div className="services-cards">
          <div className="service-card">
            <FaShip className="service-icon" />

            <h3>Import With Us</h3>

            <p>
              Access quality vehicles from Japan, the UK,
              and other global markets. We handle
              sourcing, inspection, shipping, clearance,
              and registration for a seamless import
              experience.
            </p>

            <div className="service-footer">
              <a href="/import-guide" className="learn-more-btn">
                Learn More
                <FaArrowRight />
              </a>
            </div>
          </div>

          <div className="service-card">
            <FaMoneyCheckAlt className="service-icon" />

            <h3>Vehicle Financing</h3>

            <p>
              Drive away sooner with our flexible
              financing options. We work with trusted
              financial partners to help you secure
              affordable payment plans that fit your
              budget.
            </p>

            <div className="service-footer">
              <a href="/financing" className="learn-more-btn">
                Learn More
                <FaArrowRight />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OurServices;